import get from 'lodash/get';
import Cookies from 'yoda-core-components/lib/helpers/Cookies/Cookies';
import {
    COUPONS_APPLIED_LABEL,
    COUPON_SUBTYPE_PROMOTIONAL,
    COUPONS_UPDATE_LABEL,
    COUPON_APPLIED_SUCCESS,
    COUPON_SUBTYPE_SHIPPING,
} from '../../common/Constants';

/**
 * Coupon Utils Helper helps in  managing and extracting coupon messages
 */
class CouponUtilsHelper {
    static getAppliedCouponInfo(
        response,
        coupons,
        appliedAdjustments,
        applyingToEmptyCart,
        promoCode
    ) {
        const couponSubType = response.data && response.data.subType;
        const savings = response.data && response.data.amount;
        const couponCode = response.data && response.data.value;

        const couponDetails = coupons.find(
            (coupon) => coupon.content && coupon.content.promoCode === couponCode
        );

        let message = response.data && response.data.message;
        // MNPDPYODA-7789: if applying to empty cart (with flag on) - still show success icon
        const applyingToEmptyCartCTA =
            couponDetails && couponDetails.content ? couponDetails.content.linkUrl : '';
        let level = savings || applyingToEmptyCart ? 0 : 1;
        // MPDPYODA-4493: Test Env || Coupon applied message is not as per the comps
        // let title = (savings) ? COUPONS_APPLIED_LABEL : COUPONS_APPLIED_LABEL_EXCLUSION;
        let title = COUPONS_APPLIED_LABEL;
        /* istanbul ignore next */
        if (appliedAdjustments && appliedAdjustments.length > 0) {
            const appliedCoupons = appliedAdjustments;
            const appliedPromos = appliedCoupons.filter(
                (el) => el.subType === COUPON_SUBTYPE_PROMOTIONAL
            );
            // const appliedShippings = appliedCoupons.filter(el => el.subType === Constants.COUPON_SUBTYPE_SHIPPING);

            switch (couponSubType) {
                case COUPON_SUBTYPE_PROMOTIONAL:
                    {
                        const [
                            savedPromoCode,
                            savedPromoIndex,
                        ] = CouponUtilsHelper.getSavedPromoCodeValues();
                        /* istanbul ignore next */
                        if (!isNaN(savedPromoIndex) && savedPromoIndex > 1) {
                            title = COUPONS_UPDATE_LABEL;
                        }

                        message = !message ? COUPON_APPLIED_SUCCESS : message;

                        const applyingToEmptyCartMessage = `Add eligible products for coupon code ${couponCode}, 
                            and your discount will be reflected in your cart.`;
                        message = applyingToEmptyCart ? applyingToEmptyCartMessage : message;

                        if (appliedPromos.length > 0 && promoCode && promoCode !== savedPromoCode) {
                            Cookies.save('COUPON_STATE', `${promoCode}|${savedPromoIndex + 1}`);
                        }
                    }
                    break;

                case COUPON_SUBTYPE_SHIPPING:
                    if (message === null) {
                        title = COUPONS_APPLIED_LABEL;
                        level = 0;
                    }
                    break;

                default:
                    break;
            }
        } // end of applied adjustments

        if (message === null) message = '';

        return {
            title,
            savings,
            message,
            level,
            applyingToEmptyCartCTA,
        };
    }

    static getSavedPromoCodeValues() {
        const value = Cookies.load('COUPON_STATE');
        if (value) {
            const splitValue = value.split('|');
            const code = get(splitValue, '[0]', '');
            const index = Number(get(splitValue, '[1]', 0));
            return [code, index];
        }
        return ['', 0];
    }

    static removePromoCode() {
        Cookies.remove('COUPON_STATE');
    }

    static savePromoCode(promoCode) {
        const [savedPromoCode, index] = CouponUtilsHelper.getSavedPromoCodeValues();
        if (promoCode && promoCode !== savedPromoCode) {
            Cookies.save('COUPON_STATE', `${promoCode}|${index + 1}`);
        }
    }
}

export default CouponUtilsHelper;
